import React, { Component } from "react";
import { connect } from "react-redux";
import {
  selectedTest,
  selectedCategory
} from "../../../../features/selections/selectActions";
import { withRouter } from "react-router-dom";
import { Segment, Item, Button, List } from "semantic-ui-react";
import { Link } from "react-router-dom";
import moment from "moment";
import UserActivityListAttendee from "./UserActivityListAttendee";
import AttendeeListModal from "./AttendeeListModal";
import { FacebookShareButton, FacebookIcon } from "react-share";

// import emotion
import { css } from "emotion";

// import icons
import { FaFacebook } from "react-icons/fa";

// import react-custom-share components
import { ShareButtonRectangle, ShareBlockStandard } from "react-custom-share";

const ShareComponent = props => {
  // create object with props for shareBlock
  const shareBlockProps = {
    url: "https://react-app-c1d18.firebaseapp.com/",
    button: ShareButtonRectangle,
    buttons: [{ network: "Facebook", icon: FaFacebook }],
    text: `Give it a try!`,
    longtext: `I have just scored ${props.score} in ${props.testId}!`
  };

  return <ShareBlockStandard {...shareBlockProps} />;
};

const actions = {
  selectedTest,
  selectedCategory
};

const mapState = state => ({
  selectedCategory: state.selection.selectedCategory,
  selectedTest: state.selection.selectedTest
});

class UserActivityListItem extends Component {
  shareUrl = "https://react-app-c1d18.firebaseapp.com/categoryTestPage";
  state = {
    openModal: false
  };

  redirectToTestPage = value => () => {
    const { selectedTest, selectedCategory } = this.props;
    selectedCategory(value.testCollection);
    selectedTest(value.testId);

    this.props.history.push({
      pathname: "/testDetailPage"
    });
  };

  closeModal = () => {
    this.setState({
      openModal: false
    });
  };

  showModal = attendeeListModal => () => {
    console.log("showModal() ", attendeeListModal);
    this.setState({
      openModal: true
    });
  };

  render() {
    const { activity } = this.props;
    const timeStamp = new Date(activity.takenAt.seconds * 1000);
    const time = moment(timeStamp).format("LLL");
    let attendeeListDisplay = [];
    let attendeeListModal = [];
    if (activity.attendees.length > 2) {
      attendeeListDisplay = activity.attendees.slice(0, 2);
      attendeeListModal = activity.attendees.slice(
        2,
        activity.attendees.length
      );
      // console.log("activity activity activity ", activity);
      // console.log("list item displayed ", attendeeListDisplay);
      // console.log("list item for modal ", attendeeListModal);
    } else {
      attendeeListDisplay = activity.attendees;
    }

    // console.log("UserActivityListItem() time ", time);
    // const { attendees } = this.objectToArray(testAttended);
    // console.log("profile attendees ", profile, testAttended);
    return (
      <Segment.Group>
        <Segment>
          <Item.Group>
            <Item>
              {/* <Item.Image
                                size="tiny"
                                circular
                                src={profile.photoURL}
                            /> */}
              <Item.Content>
                <Item.Header
                  as={Link}
                  onClick={this.redirectToTestPage(activity)}
                  to={`/testDetailPage`}
                >
                  {activity.testId}
                </Item.Header>
                <Item.Description>
                  <h4
                    style={{
                      color: "blue"
                    }}
                  >
                    Your Score: {activity.testScore}
                  </h4>

                  {/* <Link to={`/profile/${profile.id}`}>
                                        {profile.displayName}
                                    </Link> */}
                </Item.Description>

                {/* {event.cancelled &&
            <Label style={{top: '-40px'}} ribbon='right' color='red' content='This event has been cancelled'/>} */}
              </Item.Content>
            </Item>
          </Item.Group>
        </Segment>
        <Segment>
          <span>
            {/* <Icon name="clock" /> */}
            <h4>{`Test Taken At: ${time}`}</h4>
          </span>
        </Segment>

        <Segment secondary>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "baseline"
            }}
          >
            <h4
              style={{
                marginRight: "20px"
              }}
            >
              Test Attended so far:{" "}
            </h4>

            <List horizontal>
              {attendeeListDisplay &&
                attendeeListDisplay.map(attendee => (
                  <UserActivityListAttendee
                    key={attendee.id}
                    attendee={attendee}
                  />
                ))}
            </List>

            {attendeeListModal.length > 0 && (
              <Button
                primary
                onClick={this.showModal(attendeeListModal)}
                style={{
                  marginLeft: "20px"
                }}
              >{`+${attendeeListModal.length} more`}</Button>
            )}
            <AttendeeListModal
              open={this.state.openModal}
              attendees={attendeeListModal}
              close={this.closeModal}
            />
          </div>
        </Segment>
        <Segment clearing>
          {/* <span>{activity.collection}</span> */}
          {/* <Button color="facebook" floated="right">
            <Icon name="facebook" /> Facebook
          </Button> */}
          {/* <FacebookShareButton
            url={this.shareUrl}
            style={{
              width: "50px",
              height: "50px",
              cursor: "pointer",
              float: "right",
              textAlign: "center"
            }}
          >
            <FacebookIcon size={32} round={true} />
          </FacebookShareButton> */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "baseline"
            }}
          >
            <h4
              style={{
                marginRight: "20px"
              }}
            >
              Would you like to share this test?
            </h4>

            <ShareComponent
              testId={activity.testId}
              score={activity.testScore}
            />
          </div>
        </Segment>
      </Segment.Group>
    );
  }
}

export default withRouter(
  connect(
    mapState,
    actions
  )(UserActivityListItem)
);
